import { FileDownloadIcon, TablePager } from '@fukuri-admins/ui/common';
import { AccessLogTableContent } from '~/components/accessLog/AccessLogTableContent';
import { ActionButton } from '~/components/common/ActionButton';
import { ContentsHeader } from '~/components/common/ContentsHeader';
import Shimmer from '~/components/Shimmer';
import styles from './styles.module.scss';

type AccessLogTableContentProps = React.ComponentProps<typeof AccessLogTableContent>;
type TablePagerProps = React.ComponentProps<typeof TablePager>;
type Props = {
  rows: AccessLogTableContentProps['rows'];
  currentPage: TablePagerProps['currentPage'];
  totalPage: TablePagerProps['totalPage'];
  totalCount: TablePagerProps['totalCount'];
  itemCount: TablePagerProps['itemCount'];
  isLoading: boolean;
  onSort: AccessLogTableContentProps['onSort'];
  onPageChange: TablePagerProps['onPageChange'];
  onOutputCsv: () => void;
};

export const LoginReportPresentation: React.FC<Props> = ({
  rows,
  currentPage,
  totalPage,
  totalCount,
  itemCount,
  isLoading,
  onSort,
  onPageChange,
  onOutputCsv,
}) => (
  <div className={styles.Root}>
    <div className={styles.container}>
      <ContentsHeader
        title='アプリ利用履歴'
        description='以下より、1日の最初にアプリを使用した日時を確認できます。'
        actions={
          <ActionButton
            content='CSV出力'
            type='darkFill'
            icon={<FileDownloadIcon />}
            iconPosition='left'
            action={onOutputCsv}
          />
        }
      />
      {isLoading ? (
        <Shimmer />
      ) : (
        <div>
          <div className={styles.tableWrapper}>
            <AccessLogTableContent rows={rows} onSort={onSort} />
          </div>
          <TablePager
            currentPage={currentPage}
            totalPage={totalPage}
            totalCount={totalCount}
            onPageChange={onPageChange}
            itemCount={itemCount}
          />
        </div>
      )}
    </div>
  </div>
);
